@if (canShowOwnConsignments) {
  <icz-own-consignment-table
    tableTitle="Vypravení"
    [document]="document"
    [tableView]="tableView"
  ></icz-own-consignment-table>
}
@if (showOwnConsignmentsDenied) {
  <icz-alert
    heading="Nemáte dostatečné oprávnění pro zobrazení informací o zásílkách"
    class="mx-16 my-32" severity="info"
    >
  </icz-alert>
}
